import React from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Button,
    Card,
    CardMedia,
    CardContent,
    Grid,
    Typography,
    Stack,
    Link,
    IconButton,
} from "@mui/material";
import Slider from "react-slick";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import StarBorderIcon from '@mui/icons-material/StarBorder';

// Import slick carousel css
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function HomePage() {
    const navigate = useNavigate();

    const handleNavigate = (path) => {
        window.scrollTo(0, 0);
        navigate(path);
    };

    const carouselItems = [
        {
            type: "image",
            src: "/images/c1.jpg",
            alt: "Big Data",
            title: "Vensyx Data Solutions",
            subtitle: "To be a world class organization admired for consistently delivering superior Business value.",
        },
        {
            type: "image",
            src: "/images/c2.jpg",
            alt: "Enterprise Mobility",
            title: "Vensyx Data Solutions",
            subtitle: "To be a world class organization admired for consistently delivering superior Business value.",
        },
        {
            type: "image",
            src: "/images/c3.jpg",
            alt: "Business Intelligence",
            title: "Vensyx Data Solutions",
            subtitle: "To be a world class organization admired for consistently delivering superior Business value.",
        },
    ];

    const solutions = [
        {
            title: "Big Data & Advanced Analytics",
            desc: "Data is exploding. Individuals, corporates, websites, call centers, shopping malls, mobile and RFID devices etc.",
            img: "/images/bdaa.jpg",
            link: "/big-data-and-advanced-analytics",
        },
        {
            title: "Business Intelligence Solutions",
            desc: "VENSYX Data Solutions Business Intelligence Consulting Services comprise High Impact, Diagnostic.",
            img: "/images/bi.jpg",
            link: "/business-intelligence-solutions",
        },
        {
            title: "Data Management",
            desc: "VENSYX Data Solutions helps you to meet the data management goals to provide data assurance in terms of security.",
            img: "/images/dm.jpg",
            link: "/data-management",
        },
        {
            title: "Enterprise Data Warehouse",
            desc: "The data warehouse is the key behind a competent Business Intelligence system. This is the place to store.",
            img: "/images/edw.png",
            link: "/enterprise-data-warehouse",
        },
        {
            title: "Application Middleware Management",
            desc: "Middleware is the enabling technology of enterprise application integration.",
            img: "/images/amm.jpg",
            link: "/application-middleware-management",
        },
    ];

    const services = [
        {
            title: "Enterprise Mobility Services",
            desc: "In today's world, the constantly changing economy, and the boom in the global market, often poses difficult challenges for your business.",
            img: "/images/ems.webp",
            link: "/enterprise-mobility-service/business-process",
        },
        {
            title: "Mobile Apps Development",
            desc: "With the increasing use of Smart phones, there is a soaring demand for mobile applications in the market.",
            img: "/images/mad.png",
            link: "/mobile-apps-development/android-app-development",
        },
        {
            title: "Business Intelligence Services",
            desc: "Business Intelligence has transformed from being able to integrate data and create reports and dashboards.",
            img: "/images/bis.jpg",
            link: "/business-intelligence-service",
        },
        {
            title: "Web Application Development",
            desc: "Web portal service has gained popularity in the last few decades, since the internet has become accessible to the common people.",
            img: "/images/wad.jpg",
            link: "/web-application-development/CRM-application",
        },
        {
            title: "Testing and QA Services",
            desc: "VENSYX Data Solutions provides a holistic approach of testing and quality assurance to help you build a product or service through accelerated testing methods.",
            img: "/images/tqas.png",
            link: "/testing-QA-services/automated-testing",
        },
    ];

    const industries = [
        {
            title: "Telecommunications",
            desc: "The telecommunications industry has arguably evolved more than any other market sector in the last ten years.",
            img: "/images/telecommunication.jpg",
            link: "/telecommunications",
        },
        {
            title: "Retail",
            desc: "Driven by a highly competitive marketplace, today's retailer requires cutting-edge Information Management.",
            img: "/images/retail.webp",
            link: "/retail",
        },
        {
            title: "Financial Services",
            desc: "Banks are under more pressure now than ever before. Constantly evolving regulatory requirements, rising costs, economic pressures, and increased competition.",
            img: "/images/financialservices.jpg",
            link: "/financial-services",
        },
        {
            title: "Manufacturing",
            desc: "Driven by a highly competitive marketplace, today's manufacturing organization requires cutting-edge Information Management.",
            img: "/images/manufacturing.png",
            link: "/manufacturing",
        },
        {
            title: "Utilities",
            desc: "As they pursue a more competitive, market-oriented business model, utilities organizations are making increasing demands on their information systems.",
            img: "/images/utility.jpg",
            link: "/utilities",
        },
        {
            title: "Government",
            desc: "Stable societies have always been those best equipped to manage, safeguard and circulate information.",
            img: "/images/goverance.jpg",
            link: "/government",
        },
    ];

    // Carousel settings
    const settings = {
        dots: true,
        infinite: true,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500,
        arrows: true,
    };

    return (
        <Box sx={{ background: "radial-gradient(circle, #AFC5DD 0%, #376DA8 100%)", }}>
            {/* Carousel Section */}
            <Box sx={{ mt: "60px", width: "100%", maxWidth: "100%", overflow: "hidden" }}>
                <Slider {...settings}>
                    {carouselItems.map((item, index) => (
                        <Box key={index} sx={{ position: "relative", width: "100%", maxWidth: "100%", mx: "auto" }}>
                            {item.type === "image" ? (
                                <img
                                    src={item.src}
                                    alt={item.alt}
                                    style={{ width: "100%", maxWidth: "100%", height: "500px", display: "block", objectFit: "cover", margin: "0 auto" }}
                                />
                            ) : (
                                <video
                                    src={item.src}
                                    controls
                                    autoPlay
                                    loop
                                    muted
                                    style={{ width: "100%", height: "500px", objectFit: "cover" }}
                                />
                            )}
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    color: "white",
                                    textAlign: "center",
                                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                                    p: 2,
                                    borderRadius: 2
                                }}
                            >
                                <Typography variant="h2" sx={{ fontWeight: "bold" }}>
                                    {item.title || "Your Title Here"}
                                </Typography>
                                <Typography variant="body1" sx={{ width: { xs: '90%', md: '50%' }, margin: '0 auto', mt: 2 }}>
                                    {item.subtitle || "Your subtitle or description here"}
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Slider>
            </Box>

            {/* Main Block */}
            <main>
                <Box sx={{ p: 3 }}>
                    {/* About Section */}
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: { xs: "column", md: "row" },
                            gap: 4,
                            py: 5,
                        }}
                    >
                        <Box flex={1}>
                            <Typography variant="h4" align="center" gutterBottom>
                                About VENSYX
                            </Typography>
                            <Typography
                                sx={{ fontFamily: "Raleway, sans-serif", textAlign: "justify" }}
                            >
                                VENSYX Data Solutions is your Innovation to provide
                                world-class Big Data, Business Intelligence, Data
                                Integration, Data Quality, Data Warehousing, Data
                                Governance, and Master Data Management services
                                and solutions to companies around the globe and
                                across industries. VENSYX Data Solutions has been
                                helping business and technology work together to
                                protect existing data investments and unlock their
                                business value using the most advanced tools,
                                technologies, methodologies available and Intelligent
                                solutions for superior performance., we put emphasis
                                on long-term commitment and combine global reach
                                and local intimacy to provide premier professional
                                services from consulting, system development to
                                business IT outsourcing.
                            </Typography>

                            <Button
                                variant="contained"
                                onClick={() => handleNavigate("/aboutus")}
                                sx={{
                                    mt: 3,
                                    px: 4,
                                    py: 1.2,
                                    fontSize: "16px",
                                    fontWeight: 600,
                                    borderRadius: "30px",
                                    textTransform: "none",
                                    background: "linear-gradient(90deg, #030366 0%, #1976d2 100%)",
                                    color: "#fff",
                                    boxShadow: "0px 4px 10px rgba(3, 3, 102, 0.3)",
                                    transition: "all 0.3s ease",
                                    "&:hover": {
                                        background: "linear-gradient(90deg, #1976d2 0%, #030366 100%)",
                                        boxShadow: "0px 6px 12px rgba(3, 3, 102, 0.4)",
                                        transform: "translateY(-2px)",
                                    },
                                }}
                            >
                                EXPLORE
                            </Button>

                        </Box>
                        <Box flex={1}>
                            <Card>
                                <CardContent>
                                    <video
                                        src="video/aboutvideo1.mp4"
                                        type="video/mp4"
                                        controls
                                        width="100%"
                                    />
                                </CardContent>
                            </Card>
                        </Box>
                    </Box>

                    {/* Corporate Cards */}
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: { xs: "column", sm: "column", md: "row" },
                            justifyContent: "center",
                            alignItems: "center",
                            gap: { xs: 4, sm: 8 },
                            mb: 5,
                        }}
                    >
                        {/* Card 1 */}
                        <Box sx={{ perspective: "1000px" }}>
                            <Box
                                className="flip-card"
                                sx={{
                                    position: "relative",
                                    width: "260px",
                                    height: "360px",
                                    transformStyle: "preserve-3d",
                                    transition: "transform 1s",
                                    "&:hover": { transform: "rotateY(180deg)" },
                                }}
                            >
                                {/* Front */}
                                <Card
                                    sx={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        backfaceVisibility: "hidden !important",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        textAlign: "center",
                                        borderRadius: 3,
                                        boxShadow: 4,
                                        background: "linear-gradient(135deg, #1976d2, #90caf9)",
                                        color: "white",
                                    }}
                                >
                                    <CardContent sx={{ textAlign: "center" }}>
                                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                                            Vision & Mission
                                        </Typography>
                                        <Box
                                            component="img"
                                            src="/images/vision_mission.png"
                                            alt="Vision Mission"
                                            sx={{
                                                mt: 2,
                                                width: "100%",
                                                height: "200px",
                                                objectFit: "cover",
                                                borderRadius: 2,
                                            }}
                                        />
                                    </CardContent>
                                </Card>

                                {/* Back */}
                                <Card
                                    sx={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        backfaceVisibility: "hidden !important",
                                        transform: "rotateY(180deg)",
                                        borderRadius: 3,
                                        boxShadow: 4,
                                        p: 2,
                                    }}
                                >
                                    <CardContent>
                                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                                            Vision & Mission
                                        </Typography>
                                        <Typography variant="body2" gutterBottom>
                                            • To be a world class organization admired for consistently delivering superior Business value.
                                        </Typography>
                                        <Typography variant="body2">
                                            • We will win by excelling in execution and by ensuring total customer satisfaction.
                                        </Typography>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            sx={{ mt: 2, textTransform: "none", borderRadius: 6 }}
                                            onClick={() => handleNavigate("/vision-mission")}
                                        >
                                            Read more
                                        </Button>
                                    </CardContent>
                                </Card>
                            </Box>
                        </Box>
                        {/* Card 2 */}
                        <Box sx={{ perspective: "1000px" }}>
                            <Box
                                className="flip-card"
                                sx={{
                                    position: "relative",
                                    width: "260px",   // fixed width for equal cards
                                    height: "360px",
                                    transformStyle: "preserve-3d",
                                    transition: "transform 1s",
                                    "&:hover": { transform: "rotateY(180deg)" },
                                }}
                            >
                                {/* Front */}
                                <Card
                                    sx={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        backfaceVisibility: "hidden !important",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        textAlign: "center",
                                        borderRadius: 3,
                                        boxShadow: 4,
                                        background: "linear-gradient(135deg, #1976d2, #90caf9)",
                                        color: "white",
                                    }}
                                >
                                    <CardContent sx={{ textAlign: "center" }}>
                                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                                            Core Value
                                        </Typography>
                                        <Box
                                            component="img"
                                            src="/images/core-removebg-preview.png"
                                            alt="Core Value"
                                            sx={{
                                                mt: 2,
                                                width: "100%",
                                                height: "200px",
                                                objectFit: "cover",
                                                borderRadius: 2,
                                            }}
                                        />
                                    </CardContent>
                                </Card>

                                {/* Back */}
                                <Card
                                    sx={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        backfaceVisibility: "hidden !important",
                                        transform: "rotateY(180deg)",
                                        borderRadius: 3,
                                        boxShadow: 4,
                                        p: 2,
                                    }}
                                >
                                    <CardContent>
                                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                                            Core Value
                                        </Typography>
                                        <Typography variant="body2" gutterBottom>
                                            • We ensure customer satisfaction by adding value and honouring commitments at all times.
                                        </Typography>
                                        <Typography variant="body2">
                                            • We build transparent lasting relationships and stand for integrity and mutual trust.
                                        </Typography>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            sx={{ mt: 2, textTransform: "none", borderRadius: 6 }}
                                            onClick={() => handleNavigate("/core-value")}
                                        >
                                            Read more
                                        </Button>
                                    </CardContent>
                                </Card>
                            </Box>
                        </Box>
                        {/* Card 3 */}
                        <Box sx={{ perspective: "1000px" }}>
                            <Box
                                className="flip-card"
                                sx={{
                                    position: "relative",
                                    width: "260px",   // fixed width for equal cards
                                    height: "360px",
                                    transformStyle: "preserve-3d",
                                    transition: "transform 1s",
                                    "&:hover": { transform: "rotateY(180deg)" },
                                }}
                            >
                                {/* Front */}
                                <Card
                                    sx={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        backfaceVisibility: "hidden !important",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        textAlign: "center",
                                        borderRadius: 3,
                                        boxShadow: 4,
                                        background: "linear-gradient(135deg, #1976d2, #90caf9)",
                                        color: "white",
                                    }}
                                >
                                    <CardContent sx={{ textAlign: "center" }}>
                                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                                            Social Responsibility
                                        </Typography>
                                        <Box
                                            component="img"
                                            src="/images/History-image-removebg-preview.png"
                                            alt="Social Responsibility"
                                            sx={{
                                                mt: 2,
                                                width: "100%",
                                                height: "200px",
                                                objectFit: "cover",
                                                borderRadius: 2,
                                            }}
                                        />
                                    </CardContent>
                                </Card>

                                {/* Back */}
                                <Card
                                    sx={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        backfaceVisibility: "hidden !important",
                                        transform: "rotateY(180deg)",
                                        borderRadius: 3,
                                        boxShadow: 4,
                                        p: 2,
                                    }}
                                >
                                    <CardContent>
                                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                                            Social Responsibility
                                        </Typography>
                                        <Typography variant="body2" gutterBottom>
                                            • VENSYX Data Solutions integrates social responsibility with business objectives to make these initiatives an integral part of the company's profitable growth.
                                        </Typography>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            sx={{ mt: 2, textTransform: "none", borderRadius: 6 }}
                                            onClick={() => handleNavigate("/social-responsibility")}
                                        >
                                            Read more
                                        </Button>
                                    </CardContent>
                                </Card>
                            </Box>
                        </Box>
                    </Box>


                    {/* Solutions Section */}
                    <Typography variant="h4" align="center" gutterBottom>
                        SOLUTIONS
                    </Typography>

                    <Grid
                        container
                        spacing={2}
                        sx={{
                            py: 2,
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-around",
                            alignItems: "stretch",
                        }}
                    >
                        {solutions.map((item, i) => (
                            <Grid item xs={12} sm={6} md={4} key={i} sx={{ display: "flex" }}>
                                <Card
                                    sx={{
                                        width: "100%",
                                        maxWidth: 240,
                                        height: "350px",
                                        position: "relative",
                                        overflow: "hidden",
                                        borderRadius: 3,
                                        flex: 1,
                                        display: "flex",
                                        flexDirection: "column",

                                        // 🔑 Hide content on hover, show overlay
                                        "&:hover .defaultContent": {
                                            opacity: 0,
                                        },
                                        "&:hover .overlay": {
                                            opacity: 1,
                                            transform: "translateY(0)",
                                        },
                                    }}
                                >
                                    <CardMedia
                                        component="img"
                                        sx={{
                                            height: "100%",
                                            objectFit: "cover",
                                            filter: "brightness(0.9)",
                                        }}
                                        image={item.img}
                                        alt={item.title}
                                    />

                                    <CardContent
                                        className="defaultContent"
                                        sx={{
                                            position: "absolute",
                                            bottom: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "55%",
                                            bgcolor: "rgba(255,255,255,0.9)",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between", // text at top, button at bottom
                                            p: 2,
                                            transition: "opacity 0.3s ease",
                                        }}
                                    >
                                        {/* Text Block */}
                                        <Box sx={{ flexGrow: 1 }}>
                                            <Typography
                                                variant="h6"
                                                gutterBottom
                                                sx={{
                                                    fontSize: "15px",
                                                    fontWeight: "bold",
                                                    fontFamily: "Raleway, sans-serif",
                                                }}
                                            >
                                                {item.title}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    fontSize: "12px",
                                                    fontFamily: "Raleway, sans-serif",
                                                }}
                                            >
                                                {item.desc}
                                            </Typography>
                                        </Box>

                                        {/* Button Block */}
                                        <Box sx={{ textAlign: "center" }}>
                                            <Button
                                                variant="text"
                                                sx={{ fontWeight: "bold" }}
                                                onClick={() => handleNavigate(item.link)}
                                            >
                                                Learn More
                                            </Button>
                                        </Box>
                                    </CardContent>


                                    <Box
                                        className="overlay"
                                        sx={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            bgcolor: "rgba(0,0,0,0.8)",
                                            color: "white",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            textAlign: "center",

                                            // initially hidden
                                            opacity: 0,
                                            transform: "translateY(20px)",

                                            // animation
                                            transition: "all 0.4s ease",
                                            px: 2,
                                        }}
                                    >
                                        <Typography variant="h6" gutterBottom>
                                            {item.title}
                                        </Typography>
                                        <Typography sx={{ mb: 2, fontSize: "13px" }}>{item.desc}</Typography>
                                        <Button
                                            variant="contained"
                                            onClick={() => handleNavigate(item.link)}
                                        >
                                            Learn More
                                        </Button>
                                    </Box>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>


                    {/* Services Section */}
                    <Typography variant="h4" align="center" gutterBottom sx={{ mt: 5 }}>
                        OUR SERVICES
                    </Typography>
                    <Grid
                        container
                        spacing={2}
                        sx={{
                            py: 2,
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-around",
                            alignItems: "stretch",
                        }}
                    >
                        {services.map((item, i) => (
                            <Grid item xs={12} sm={6} md={4} key={i} sx={{ display: "flex" }}>
                                <Card
                                    sx={{
                                        width: "100%",
                                        maxWidth: 240,
                                        height: "350px",
                                        position: "relative",
                                        overflow: "hidden",
                                        borderRadius: 3,
                                        flex: 1,
                                        display: "flex",
                                        flexDirection: "column",

                                        // 🔑 Hide content on hover, show overlay
                                        "&:hover .defaultContent": {
                                            opacity: 0,
                                        },
                                        "&:hover .overlay": {
                                            opacity: 1,
                                            transform: "translateY(0)",
                                        },
                                    }}
                                >
                                    <CardMedia
                                        component="img"
                                        sx={{
                                            height: "100%",
                                            objectFit: "cover",
                                            filter: "brightness(0.9)",
                                        }}
                                        image={item.img}
                                        alt={item.title}
                                    />

                                    <CardContent
                                        className="defaultContent"
                                        sx={{
                                            position: "absolute",
                                            bottom: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "55%",
                                            bgcolor: "rgba(255,255,255,0.9)",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between", // text at top, button at bottom
                                            p: 2,
                                            transition: "opacity 0.3s ease",
                                        }}
                                    >
                                        {/* Text Block */}
                                        <Box sx={{ flexGrow: 1 }}>
                                            <Typography
                                                variant="h6"
                                                gutterBottom
                                                sx={{
                                                    fontSize: "15px",
                                                    fontWeight: "bold",
                                                    fontFamily: "Raleway, sans-serif",
                                                }}
                                            >
                                                {item.title}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    fontSize: "12px",
                                                    fontFamily: "Raleway, sans-serif",
                                                }}
                                            >
                                                {item.desc}
                                            </Typography>
                                        </Box>

                                        {/* Button Block */}
                                        <Box sx={{ textAlign: "center" }}>
                                            <Button
                                                variant="text"
                                                sx={{ fontWeight: "bold" }}
                                                onClick={() => handleNavigate(item.link)}
                                            >
                                                Learn More
                                            </Button>
                                        </Box>
                                    </CardContent>


                                    <Box
                                        className="overlay"
                                        sx={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            bgcolor: "rgba(0,0,0,0.8)",
                                            color: "white",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            textAlign: "center",

                                            // initially hidden
                                            opacity: 0,
                                            transform: "translateY(20px)",

                                            // animation
                                            transition: "all 0.4s ease",
                                            px: 2,
                                        }}
                                    >
                                        <Typography variant="h6" gutterBottom>
                                            {item.title}
                                        </Typography>
                                        <Typography sx={{ mb: 2, fontSize: "13px" }}>{item.desc}</Typography>
                                        <Button
                                            variant="contained"
                                            onClick={() => handleNavigate(item.link)}
                                        >
                                            Learn More
                                        </Button>
                                    </Box>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>


                    {/* Industries Section */}
                    <Typography variant="h4" align="center" gutterBottom sx={{ mt: 5 }}>
                        INDUSTRIES
                    </Typography>
                    <Grid
                        container
                        spacing={2}
                        sx={{
                            py: 2,
                            px: 2,
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "stretch",
                        }}
                    >
                        {industries.map((item, i) => (
                            <Grid item xs={12} sm={6} md={3} key={i} sx={{ display: "flex", justifyContent: "center" }}>
                                <Card
                                    sx={{
                                        width: "100%",
                                        maxWidth: 240,
                                        height: "350px",
                                        position: "relative",
                                        overflow: "hidden",
                                        borderRadius: 3,
                                        flex: 1,
                                        display: "flex",
                                        flexDirection: "column",

                                        // 🔑 Hide content on hover, show overlay
                                        "&:hover .defaultContent": {
                                            opacity: 0,
                                        },
                                        "&:hover .overlay": {
                                            opacity: 1,
                                            transform: "translateY(0)",
                                        },
                                    }}
                                >
                                    <CardMedia
                                        component="img"
                                        sx={{
                                            height: "100%",
                                            objectFit: "cover",
                                            filter: "brightness(0.9)",
                                        }}
                                        image={item.img}
                                        alt={item.title}
                                    />

                                    <CardContent
                                        className="defaultContent"
                                        sx={{
                                            position: "absolute",
                                            bottom: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "55%",
                                            bgcolor: "rgba(255,255,255,0.9)",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between", // text at top, button at bottom
                                            p: 2,
                                            transition: "opacity 0.3s ease",
                                        }}
                                    >
                                        {/* Text Block */}
                                        <Box sx={{ flexGrow: 1 }}>
                                            <Typography
                                                variant="h6"
                                                gutterBottom
                                                sx={{
                                                    fontSize: "15px",
                                                    fontWeight: "bold",
                                                    fontFamily: "Raleway, sans-serif",
                                                }}
                                            >
                                                {item.title}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    fontSize: "12px",
                                                    fontFamily: "Raleway, sans-serif",
                                                }}
                                            >
                                                {item.desc}
                                            </Typography>
                                        </Box>

                                        {/* Button Block */}
                                        <Box sx={{ textAlign: "center" }}>
                                            <Button
                                                variant="text"
                                                sx={{ fontWeight: "bold" }}
                                                onClick={() => handleNavigate(item.link)}
                                            >
                                                Learn More
                                            </Button>
                                        </Box>
                                    </CardContent>


                                    <Box
                                        className="overlay"
                                        sx={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            bgcolor: "rgba(0,0,0,0.8)",
                                            color: "white",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            textAlign: "center",

                                            // initially hidden
                                            opacity: 0,
                                            transform: "translateY(20px)",

                                            // animation
                                            transition: "all 0.4s ease",
                                            px: 2,
                                        }}
                                    >
                                        <Typography variant="h6" gutterBottom>
                                            {item.title}
                                        </Typography>
                                        <Typography sx={{ mb: 2, fontSize: "13px" }}>{item.desc}</Typography>
                                        <Button
                                            variant="contained"
                                            onClick={() => handleNavigate(item.link)}
                                        >
                                            Learn More
                                        </Button>
                                    </Box>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </main >
        </Box >
    );
}

export default HomePage;
